/* Dauber HQ staggered scroll reveal (Apple macOS-style).
 * Elements fade in + rise, staggered, and STAY revealed (one-shot).
 *
 * GROUP-TRIGGERED: the trigger is the GROUP, not the element. Once a group's
 * container scrolls into view, EVERY item in it cascades (by its staggered delay)
 * — including items still below the fold — so there's no per-item wait as you
 * scroll past. A group is the nearest [data-reveal-group] ancestor, or failing
 * that the item's <section>. Mark a sub-region (e.g. an FAQ category) with
 * data-reveal-group to make it fade in on its own as it's reached.
 *
 * Targets are pre-hidden via CSS (_motion.scss) gated on <html>.reveal-on, which
 * an inline <head> script sets unless prefers-reduced-motion. This module reveals
 * the same elements inside main[data-reveal] (off on legal / blog & support posts).
 *
 * REVEAL_SELECTOR is mirrored in web/assets/scss/_motion.scss — keep in sync.
 */

(function () {
  'use strict';

  // Prove the bundle loaded + executed, so the inline head-script safety timer
  // doesn't strip .reveal-on (which would un-hide content this module reveals).
  document.documentElement.classList.add('reveal-ready');

  // Kept in sync with web/assets/scss/_motion.scss ($reveal-targets + exclusions).
  // Two kinds of target:
  //  1. GENERIC section intros — prose matched by REVEAL_SELECTOR, sibling-staggered.
  //     No `li`/`figure` (structural / horizontally-scrolled cards never intersect);
  //     CARD_ANCESTORS content and anything inside a [data-reveal-item] is skipped.
  //  2. [data-reveal-item] — an element that fades up as a WHOLE UNIT (a card, the
  //     gallery shelf, a toggle, a board panel). Its inner prose does NOT stagger.
  //     Sequence with data-reveal-order="N" (delay = N * STEP); elements sharing an
  //     order fade together. Lets a section choreograph (e.g. toggle with subtitle,
  //     board after) without revealing every leaf.
  var REVEAL_SELECTOR = '.eyebrow, h1, h2, h3, h4, p, blockquote, .cta__actions';
  var CARD_ANCESTORS = '.hf-glass, .fg-card';
  var STEP = 80; // ms between staggered siblings
  var CAP = 6;   // max stagger steps, so long groups don't cascade forever

  if (!document.documentElement.classList.contains('reveal-on')) return; // reduced-motion / disabled
  var root = document.querySelector('main[data-reveal]');
  if (!root) return;

  // Skip hero sections (homepage .hero + subpage *-hero variants) — mirrors the
  // section:not([class*='hero']) guard in CSS.
  var sections = Array.prototype.filter.call(
    root.querySelectorAll('section'),
    function (s) { return !/hero/.test(s.className); }
  );
  // Each item is bucketed into a group; the group's container is what we observe.
  var groups = []; // [{ el: groupEl, items: [el, …] }]

  function bucketFor(groupEl) {
    for (var i = 0; i < groups.length; i++) if (groups[i].el === groupEl) return groups[i];
    var g = { el: groupEl, items: [] };
    groups.push(g);
    return g;
  }
  function arm(el, steps, section) {
    el.style.transitionDelay = (Math.min(steps, CAP) * STEP) + 'ms';
    bucketFor(el.closest('[data-reveal-group]') || section).items.push(el);
  }

  sections.forEach(function (section) {
    // 1. Generic intros.
    Array.prototype.forEach.call(section.querySelectorAll(REVEAL_SELECTOR), function (el) {
      if (el.closest(CARD_ANCESTORS)) return;       // inside a card — leave it static
      if (el.closest('[data-reveal-item]')) return; // owned by a whole-unit item
      // Stagger index = position among matched siblings sharing the same parent.
      var sibs = Array.prototype.filter.call(el.parentNode.children, function (c) {
        return c.matches && c.matches(REVEAL_SELECTOR) && !c.hasAttribute('data-reveal-item');
      });
      var idx = sibs.indexOf(el);
      arm(el, idx < 0 ? 0 : idx, section);
    });
    // 2. Whole-unit items — top-most only (don't double-reveal nested items).
    Array.prototype.forEach.call(section.querySelectorAll('[data-reveal-item]'), function (el) {
      if (el.parentElement && el.parentElement.closest('[data-reveal-item]')) return;
      var ord = el.getAttribute('data-reveal-order');
      arm(el, ord !== null ? (parseInt(ord, 10) || 0) : 0, section);
    });
  });

  if (!groups.length) return;

  function reveal(g) { g.items.forEach(function (el) { el.classList.add('is-in'); }); }

  // Position-based sweep, not IntersectionObserver: a group reveals once its top
  // crosses the trigger line (viewport bottom minus 8%), AND any group already
  // scrolled past it (top < line, incl. negative) reveals too. This is robust to
  // instant jumps — anchor links, scroll restoration, fast flicks — where IO may
  // never fire because the element's intersection ratio never crosses zero.
  var pending = groups.slice();
  function sweep() {
    var line = window.innerHeight * 0.80; // trigger ~20% up from the bottom, so the
                                          // cascade plays in view rather than at the
                                          // very edge where the fade gets missed
    for (var i = pending.length - 1; i >= 0; i--) {
      if (pending[i].el.getBoundingClientRect().top < line) {
        reveal(pending[i]);
        pending.splice(i, 1);
      }
    }
    if (!pending.length) {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    }
  }
  var raf = 0;
  function onScroll() { if (!raf) raf = requestAnimationFrame(function () { raf = 0; sweep(); }); }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  sweep(); // initial: above-fold groups + whatever a restored/anchored scroll lands on
})();
